/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseField } from './DatabaseField';
import {
    DatabaseFieldFromJSON,
    DatabaseFieldFromJSONTyped,
    DatabaseFieldToJSON,
} from './DatabaseField';
import type { DatabaseFieldPreviewOptions } from './DatabaseFieldPreviewOptions';
import {
    DatabaseFieldPreviewOptionsFromJSON,
    DatabaseFieldPreviewOptionsFromJSONTyped,
    DatabaseFieldPreviewOptionsToJSON,
} from './DatabaseFieldPreviewOptions';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabaseYesNoFieldLook } from './DatabaseYesNoFieldLook';
import {
    DatabaseYesNoFieldLookFromJSON,
    DatabaseYesNoFieldLookFromJSONTyped,
    DatabaseYesNoFieldLookToJSON,
} from './DatabaseYesNoFieldLook';

/**
 * 
 * @export
 * @interface DatabaseYesNoField
 */
export interface DatabaseYesNoField extends DatabaseField {
    /**
     * 
     * @type {string}
     * @memberof DatabaseYesNoField
     */
    activeText?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseYesNoField
     */
    inactiveText?: string;
    /**
     * 
     * @type {DatabaseYesNoFieldLook}
     * @memberof DatabaseYesNoField
     */
    type?: DatabaseYesNoFieldLook;
    /**
     * Toggle background color (CSS color string)
     * @type {string}
     * @memberof DatabaseYesNoField
     */
    backgroundColor?: string;
    /**
     * Toggle color when value is true / on
     * @type {string}
     * @memberof DatabaseYesNoField
     */
    onColor?: string;
    /**
     * Toggle color when value is false / off
     * @type {string}
     * @memberof DatabaseYesNoField
     */
    offColor?: string;
}

/**
 * Check if a given object implements the DatabaseYesNoField interface.
 */
export function instanceOfDatabaseYesNoField(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseYesNoFieldFromJSON(json: any): DatabaseYesNoField {
    return DatabaseYesNoFieldFromJSONTyped(json, false);
}

export function DatabaseYesNoFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseYesNoField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseFieldFromJSONTyped(json, ignoreDiscriminator),
        'activeText': !exists(json, 'activeText') ? undefined : json['activeText'],
        'inactiveText': !exists(json, 'inactiveText') ? undefined : json['inactiveText'],
        'type': !exists(json, 'type') ? undefined : DatabaseYesNoFieldLookFromJSON(json['type']),
        'backgroundColor': !exists(json, 'backgroundColor') ? undefined : json['backgroundColor'],
        'onColor': !exists(json, 'onColor') ? undefined : json['onColor'],
        'offColor': !exists(json, 'offColor') ? undefined : json['offColor'],
    };
}

export function DatabaseYesNoFieldToJSON(value?: DatabaseYesNoField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseFieldToJSON(value),
        'activeText': value.activeText,
        'inactiveText': value.inactiveText,
        'type': DatabaseYesNoFieldLookToJSON(value.type),
        'backgroundColor': value.backgroundColor,
        'onColor': value.onColor,
        'offColor': value.offColor,
    };
}

